import FirmwareConfig from "@/model/FirmwareConfig";

export class FconfigEditForm {
    productId = -1
    dir?: string = undefined

    init(fconfig: FirmwareConfig): void {
        this.productId = fconfig.productId
        this.dir = fconfig.dir
    }
}
